<template>
  <div class="banner_top" id="bannerTop">
    <img src="../common/images/banner/banner_title2.png" class="banner_title" />
    <div class="banner_bread">
      <div class="bread_item" v-for="(item,index) in itemList" :key="index" @click="goto(item.url)" @mouseover="mouseOver($event)"
        @mouseleave="mouseLeave($event)" :class="{ 'active': item.url==$parent.curPage }" :data-url="item.url">{{item.title}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'topBanner',
    props:['curPage'],
    data() {
      return {
        itemList: [{
            title: "网站首页",
            url: "/"
          },
          {
            title: "点服环境",
            url: "nodeService"
          },
          {
            title: "产品服务",
            url: "mainBusiness"
          },
          {
            // title: "成功案例",
            title: "智能硬件",
            url: "hardWare"
          },
          {
            title: "新闻资讯",
            url: "newsCenter"
          },
          {
            title: "关于我们",
            url: "aboutUs"
          }
        ]
      }
    },
    methods: {
      mouseOver($event) {
        $event.currentTarget.className = "bread_item active";
      },
      mouseLeave($event) {
        var curPage = this.$parent.curPage
        if(curPage==$event.currentTarget.dataset.url){

        }else{
          $event.currentTarget.className = "bread_item";
        }
      },
      goto(e){
        this.$router.push({
          path:e
        })
      },
    }
  }
</script>

<style>
  .banner_top {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    width: 1920px;
    height: 140px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #ffffff38;
  }

  .banner_title {
    width: 412px;
    height: 45px;
    margin: 47px 78px 0 210px;
  }

  .banner_bread {
    width: 1128px;
    height: 140px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .bread_item {
    width: 188px;
    height: 140px;
    line-height: 140px;
    text-align: center;
    font-size: 24px;
    justify-content: center;
    color: #fff;
    /* font-weight: 600; */
    cursor: pointer;
  }

  .active {
    height: 135px;
    color: #2caeff;
    border-bottom: 5px solid #2caeff;
  }

  .el-carousel__indicator--horizontal {
    padding: 12px 30px !important;
  }

  .el-carousel__button {
    width: 16px !important;
    height: 16px !important;
    border-radius: 8px !important;
    background-color: rgba(255, 255, 255, 0.0) !important;
    border: 3px solid #fff !important;
    opacity: 1;
  }

  .is-active .el-carousel__button {
    background-color: rgba(255, 255, 255, 1.0) !important;
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/topBanner.vue